@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.bi."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="hygiene" let-item="item">
            <span
                [pTooltip]="('form.bi.hygieneOptions.' + item.data.hygiene) | translate"
            >{{ item.data.hygiene }}</span>
        </ng-template>

        <ng-template pTemplate="eatDrink" let-item="item">
            <span
                [pTooltip]="('form.bi.eatDrinkOptions.' + item.data.eatDrink) | translate"
            >{{ item.data.eatDrink }}</span>
        </ng-template>

        <ng-template pTemplate="dressing" let-item="item">
            <span
                [pTooltip]="('form.bi.dressingOptions.' + item.data.dressing) | translate"
            >{{ item.data.dressing }}</span>
        </ng-template>

        <ng-template pTemplate="showering" let-item="item">
            <span
                [pTooltip]="('form.bi.showeringOptions.' + item.data.showering) | translate"
            >{{ item.data.showering }}</span>
        </ng-template>

        <ng-template pTemplate="toilet" let-item="item">
            <span
                [pTooltip]="('form.bi.toiletOptions.' + item.data.toilet) | translate"
            >{{ item.data.toilet }}</span>
        </ng-template>

        <ng-template pTemplate="moving" let-item="item">
            <span
                [pTooltip]="('form.bi.movingOptions.' + item.data.moving) | translate"
            >{{ item.data.moving }}</span>
        </ng-template>

        <ng-template pTemplate="stairs" let-item="item">
            <span
                [pTooltip]="('form.bi.stairsOptions.' + item.data.stairs) | translate"
            >{{ item.data.stairs }}</span>
        </ng-template>

        <ng-template pTemplate="walking" let-item="item">
            <span
                [pTooltip]="('form.bi.walkingOptions.' + item.data.walking) | translate"
            >{{ item.data.walking }}</span>
        </ng-template>

        <ng-template pTemplate="stool" let-item="item">
            <span
                [pTooltip]="('form.bi.stoolOptions.' + item.data.stool) | translate"
            >{{ item.data.stool }}</span>
        </ng-template>

        <ng-template pTemplate="urine" let-item="item">
            <span
                [pTooltip]="('form.bi.urineOptions.' + item.data.urine) | translate"
            >{{ item.data.urine }}</span>
        </ng-template>

    </app-table>
}
